// client/src/hooks/usePromoterRef.js
//
// Public pages opened with ?ref=CODE (a promoter's code, Growth Phase 2)
// report it once per tab so the visit is credited to that promoter, exactly
// like a click on their /c/ link. The server resolves the code within the
// page's tenant and sets the os_vid cookie that checkout later sends.
//
//   usePromoterRef({ tenantSlug, eventSlug })            // /ev/:tenantSlug/:eventSlug
//   usePromoterRef({ tenantSlug, eventId, itemId })      // /e/:tenantSlug/:eventId/:itemId

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';
const CODE_RE = /^[A-Za-z0-9_-]{3,32}$/;

export function readRefCode(search) {
  try {
    const code = new URLSearchParams(search || '').get('ref');
    return code && CODE_RE.test(code) ? code.toUpperCase() : null;
  } catch {
    return null;
  }
}

export default function usePromoterRef({ tenantSlug, eventSlug, eventId, itemId }) {
  const { search, pathname } = useLocation();
  useEffect(() => {
    const code = readRefCode(search);
    if (!code || !tenantSlug || (!eventSlug && !eventId)) return;
    const key = `os_ref:${code}:${pathname}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch { /* storage blocked: report anyway (the server de-dupes touches) */ }
    fetch(`${BASE_URL}/api/promoters/ref`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tenantSlug, code, eventSlug: eventSlug || undefined, eventId: eventId || undefined, itemId: itemId || undefined }),
    }).catch(() => {});
  }, [search, pathname, tenantSlug, eventSlug, eventId, itemId]);
}
